import GSAP from 'gsap';

export default class Chat {
  constructor({ element }) {
    this.element = element;
    this.wrapper = this.element.querySelector('.whatsapp__wrapper');
    this.icon = this.wrapper.querySelector('.whatsapp__icon');
    this.text = this.wrapper.querySelector('.whatsapp__text');

    this._splitChars();

    GSAP.set(this.text, { width: 0 });
    GSAP.set(this.chars, { y: 8, opacity: 0 });
    GSAP.set(this.wrapper, { gap: 0 });

    this._handleMouseEnter = this._animateIn.bind(this);
    this._handleMouseLeave = this._animateOut.bind(this);

    this.mm = GSAP.matchMedia();
    this.init();
  }

  _splitChars() {
    const raw = this.text.textContent.trim();
    this.text.innerHTML = raw
      .split('')
      .map(c =>
        c === ' '
          ? `<span style="width:5px;display:inline-block">&nbsp;</span>`
          : `<span style="display:inline-block">${c}</span>`,
      )
      .join('');
    this.chars = this.text.querySelectorAll('span');
  }

  init() {
    GSAP.set(this.text, { width: 'auto', visibility: 'hidden' });
    this.expandedWidth = this.text.scrollWidth;
    GSAP.set(this.text, { width: 0, visibility: 'visible' });

    this.mm.add('(min-width: 769px)', () => {
      this.element.addEventListener('mouseenter', this._handleMouseEnter);
      this.element.addEventListener('mouseleave', this._handleMouseLeave);
      return () => {
        this.element.removeEventListener('mouseenter', this._handleMouseEnter);
        this.element.removeEventListener('mouseleave', this._handleMouseLeave);
      };
    });
  }

  _animateIn() {
    GSAP.killTweensOf([this.text, this.chars, this.wrapper, this.icon]);

    GSAP.to(this.wrapper, { gap: 8, duration: 0.7, ease: 'expo.out' });
    GSAP.to(this.text, {
      width: this.expandedWidth,
      duration: 0.75,
      ease: 'expo.out',
    });

    GSAP.fromTo(
      this.chars,
      { y: 8, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        stagger: 0.025,
        delay: 0.1,
        duration: 0.5,
        ease: 'power3.out',
      },
    );

    // subtle fade-nudge — no bounce, no scale
    GSAP.fromTo(
      this.icon,
      { opacity: 0.6, y: 2 },
      { opacity: 1, y: 0, duration: 0.4, ease: 'power2.out' },
    );
  }

  _animateOut() {
    GSAP.killTweensOf([this.text, this.chars, this.wrapper, this.icon]);

    GSAP.to(this.icon, {
      opacity: 0.6,
      y: 2,
      duration: 0.3,
      ease: 'power2.in',
    });

    GSAP.to(this.chars, {
      y: -5,
      opacity: 0,
      stagger: 0.016,
      duration: 0.22,
      ease: 'power2.in',
    });
    GSAP.to(this.text, {
      width: 0,
      duration: 0.45,
      delay: 0.12,
      ease: 'expo.in',
    });
    GSAP.to(this.wrapper, {
      gap: 0,
      duration: 0.4,
      delay: 0.1,
      ease: 'expo.in',
    });
  }

  destroy() {
    GSAP.killTweensOf([this.text, this.chars, this.wrapper, this.icon]);
    this.mm.revert();
    this.element.removeEventListener('mouseenter', this._handleMouseEnter);
    this.element.removeEventListener('mouseleave', this._handleMouseLeave);
    Object.keys(this).forEach(k => (this[k] = null));
  }
}
